export default [
  {
    path: '/senior-house-office',
    name: 'senior-house-office',
    component: () => import('@/views/seniorOffice/SeniorHouseOffice.vue'),
  },
  {
    path: '/vital-signs/:name/:id/:is_active',
    name: 'vital-signs',
    component: () => import('@/views/seniorOffice/VitalSigns.vue'),
  },
  {
    path: '/doctor-notes-list/:name/:id/:is_active',
    name: 'doctor-notes-list',
    component: () => import('@/views/seniorOffice/DoctorNotesListView.vue'),
  },
  {
    path: '/follow-up-list/:name/:id/:is_active',
    name: 'follow-up-list',
    component: () => import('@/views/seniorOffice/FollowUp.vue'),
  },
  {
    path: '/blood-compatibility',
    name: 'blood-compatibility',
    component: () => import('@/views/seniorOffice/BloodCompatibility.vue'),
  },
  {
    path: '/blood-compatibility-update/:blood_compatibility_id/:pateint_card_id',
    name: 'blood-compatibility-update',
    component: () => import('@/views/seniorOffice/UpdateBloodCompatibility.vue'),
  },
  {
    path: '/blood-transfusions-sho',
    name: 'blood-transfusions-sho',
    component: () => import('@/views/seniorOffice/ShoBloodTransfusions.vue'),
  },
  {
    path: '/test2',
    name: 'test2',
    component: () => import('@/components/printables/TransfusionNote.vue'),
  },
]
